// import React, { useState ,useContext} from "react"
// import '../Styles/navbar.css'
// import { Link } from "react-router-dom"
// import { FaBars } from "react-icons/fa"
// import { ImCross } from "react-icons/im"
// import { AuthContext } from '../../context/auth';

// export default function Navbar() {
//   const [Mobile, setMobile] = useState(false)
//   const {user,logout}=useContext(AuthContext);

//   const menuBar=user?(
// <>
//     <nav className='navbar'>
//         <h3 className='logo'>Pic Forest </h3> 
        
//         <ul className={Mobile ? "nav-links-mobile" : "nav-links"} onClick={() => setMobile(false)}>
//           <Link to='/' className='home'>
//             <li>Home</li>
//           </Link>
//           <Link to='/about' className='about'>
//             <li>About</li>
//           </Link>
//           <Link to='/contact' className='services'>
//             <li>Contact</li>
//           </Link>
//           <Link to="/"  className='logout'>
//             <li onClick={logout}>Logout</li>
//           </Link>
//         </ul>
      
//         <button className='mobile-menu-icon' onClick={() => setMobile(!Mobile)}>
//           {Mobile ? <ImCross /> : <FaBars />}
//         </button>
//       </nav>
//       <br></br>
//       </>
//   ):(

//     <>
//     <nav className='navbar'>
//         <h3 className='logo'>Pic Forest</h3>
        
//         <ul className={Mobile ? "nav-links-mobile" : "nav-links"} onClick={() => setMobile(false)}>
//           <Link to='/' className='home'>
//             <li>Home</li>
//           </Link>
//           <Link to='/about' className='about'>
//             <li>About</li>
//           </Link>
//           <Link to='/contact' className='services'>
//             <li>Contact</li>
//           </Link>
//           <Link to='/login' className='skills'>
//             <li>Login</li>
//           </Link>
//           <Link to='/signup' className='home'>
//             <li>Signup</li>
//           </Link>
//         </ul>
      
//         <button className='mobile-menu-icon' onClick={() => setMobile(!Mobile)}>
//           {Mobile ? <ImCross /> : <FaBars />}
//         </button>
//       </nav>
//       <br></br>
//       </>
//   )
//   return menuBar;
  
// }



import React, { useState, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaBars } from "react-icons/fa";
import { ImCross } from "react-icons/im";
import { AuthContext } from "../../context/auth";
import { Menu } from "antd";
import "../Styles/navbar.css";

export default function Navbar() {
  const [Mobile, setMobile] = useState(false);
  const { user, logout } = useContext(AuthContext);
  const location = useLocation();

  const handleNavClick = () => {
    setMobile(false);
  };

  const menuBar = user ? (
    <nav className="navbar">
      <h3 className="logo">Pic Forest</h3>

      <Menu
        className={Mobile ? "nav-links-mobile" : "nav-links"}
        mode={Mobile ? "vertical" : "horizontal"}
        onClick={handleNavClick}
        
        selectedKeys={[location.pathname]}
        
      >
        <Menu.Item key="/">
          <Link to="/" className="home">
            Home
          </Link>
        </Menu.Item>
        <Menu.Item key="/about">
          <Link to="/about" className="about">
            About
          </Link>
        </Menu.Item>
        <Menu.Item key="/contact">
          <Link to="/contact" className="services">
            Contact
          </Link>
        </Menu.Item>
        <Menu.Item key="logout" onClick={logout} className="logout">
          Logout
        </Menu.Item>
      </Menu>

      <button className="mobile-menu-icon" onClick={() => setMobile(!Mobile)}>
        {Mobile ? <ImCross /> : <FaBars />}
      </button>
    </nav>
  ) : (
    <nav className="navbar">
      <h3 className="logo">Pic Forest</h3>

      <Menu
        className={Mobile ? "nav-links-mobile" : "nav-links"}
        mode={Mobile ? "vertical" : "horizontal"}
        onClick={handleNavClick}
        selectedKeys={[location.pathname]}
      >
        <Menu.Item key="/">
          <Link to="/" className="home">
            Home
          </Link>
        </Menu.Item>
        <Menu.Item key="/about">
          <Link to="/about" className="about">
            About
          </Link>
        </Menu.Item>
        <Menu.Item key="/contact">
          <Link to="/contact" className="services">
            Contact
          </Link>
        </Menu.Item>
        <Menu.Item key="/login">
          <Link to="/login" className="skills">
            Login
          </Link>
        </Menu.Item>
        <Menu.Item key="/signup">
          <Link to="/signup" className="home">
            Signup
          </Link>
        </Menu.Item>
      </Menu>

      <button className="mobile-menu-icon" onClick={() => setMobile(!Mobile)}>
        {Mobile ? <ImCross /> : <FaBars />}
      </button>
    </nav>
  );

  return (
    <>
      {menuBar}
      <br />
    </>
  );
}
